import TEXT, { HTMLELEMENT } from '../../../DOM/text/TEXT.js';
import Switchable from '../../../../interface/Switchable.js';
import { makeAttrStruct } from '../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../enums/ModelData.js';
import { makeStruct } from '../../../../enums/MODELS.js';
// Model Structure
export const labelAttr = makeAttrStruct([
    ['for'],
    ['class']
]);
export const labelData = makeDataStruct([
    ['text'],
    ['textGroup', ''],
    ['textKey', '']
]);
export const labelModel = makeStruct([
    ['attributes', labelAttr],
    ['data', labelData]
]);
// Simplified Model
export function label(text, forAttr, className, textGroup, textKey) {
    return {
        attributes: labelAttr(forAttr, className),
        data: labelData(text, textGroup, textKey)
    };
}
/** A form field label */
export default class LABEL extends TEXT {
    constructor(node, model) {
        super(node, HTMLELEMENT.LABEL, model);
        this.implement(new Switchable(this));
    }
}
